export default{
    getByCardNo:'/weiXin/card/getByCardNo',     //查询卡券信息
    receive:'/weiXin/card/receive',     //保存地址
    check:'/weiXin/card/check', //校验卡券密码
    auth:'/wx/auth',    //根据code获取openid
    getMealList:'/weiXin/options/getList', //获取套餐列表
    bindCard:'/weiXin/card/binding', //绑定套餐
    bindOrder:'/weiXin/orders/bind',    //绑定快递单
    getUnDeliverList:'/weiXin/orders/searchNoFaHuo',    //获取未发货订单列表
    getDeliverList:'/weiXin/orders/searchFaHuo',    //获取已发货订单列表
    getUnBindList:'/weiXin/card/getUnBind',     //获取未绑定卡券
    getTodayList:'/weiXin/card/getToDay',    //获取今日绑定的卡券
    getBindList:'/weiXin/card/getBind',     //获取已绑定的卡券
    getCount:'/weiXin/card/count',      //获取今日总数、未绑定总数、已绑定总数
    updateExpressNo:'/weiXin/orders/update',        //修改快递单号
    wxConfig:'/wx/config',      //微信配置，用来做扫码功能
    unBind:'/weiXin/card/close',    //注销卡券
}